<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <label-required-field class="m-0" label="TÍTULO" />
        <v-text-field-default type="text" label="" v-model="title" />
      </div>
      <div class="col-md-12">
        <label-required-field class="m-0" label="TEXTO" />
        <ChromeSpeechToTextTextarea rows="4" max-rows="10" v-model="text" />
      </div>
      <div class="col-md-12">
        <select v-model="status" class="form-control">
          <option value="1">ATIVO</option>
          <option value="0">INATIVO</option>
        </select>
      </div>
      <div class="col-md-12 pt-0 pb-0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div class="col-md-12 text-right">
        <v-btn-save
          :disabled="loading"
          :loading="loading"
          text="SALVAR"
          @click="execute"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import VBtnSave from "../../../Components/VBtnSave.vue";

import LabelRequiredField from "../../../Components/LabelRequiredField.vue";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea.vue";

import VTextFieldDefault from "../../../Components/VTextFieldDefault.vue";

import permission from "../../../../lib/permission";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

export default {
  name: "Create",

  components: {
    ErrorsMessages,
    VBtnSave,
    LabelRequiredField,
    ChromeSpeechToTextTextarea,
    VTextFieldDefault,
  },

  props: {
    resident: Object,
    order: Object,
  },

  data() {
    return {
      title: "",
      text: "",
      status: 1,

      loading: false,

      errors: [],
    };
  },

  created() {
    let {
      order: { title, text, status },
    } = this;

    this.title = title;
    this.text = text;
    this.status = status;
  },

  methods: {
    permission,

    async execute() {
      try {
        this.loading = true;

        const {
          order: { id },
          title,
          text,
          status,
        } = this;

        let params = { id, title, text, status };

        const response = await api.put("/rest-home/resident/order", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("edit");
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
